import { camelCaseToSentenceCase } from "../../../utils";
import { DealWorkflowStage } from "../models";
import { createDealWorkflowStageKeyDate } from "./createDealWorkflowStage";

interface WorkflowTemplatePhase {
  keyDates: string[];
  phase: string;
  sequence: number;
}

const mapKeyDates = (keyDates: string[]): DealWorkflowStage["keyDates"] => {
  const stageKeyDates = keyDates
    .filter((keyDate) => keyDate.trim().length > 0)
    .map((keyDate) => createDealWorkflowStageKeyDate(camelCaseToSentenceCase(keyDate)));

  return stageKeyDates.length > 0
    ? stageKeyDates
    : [createDealWorkflowStageKeyDate("Start"), createDealWorkflowStageKeyDate("End")];
};

export const mapWorkflowTemplatePhasesToDealStages = (
  phases: WorkflowTemplatePhase[] | undefined
): DealWorkflowStage[] => {
  const dealStages =
    phases
      ?.filter((phaseItem) => phaseItem.phase.trim().length > 0)
      .sort((leftItem, rightItem) => leftItem.sequence - rightItem.sequence)
      .map((phaseItem) => ({
        description: "",
        id: `${phaseItem.sequence}-${phaseItem.phase}`,
        keyDates: mapKeyDates(phaseItem.keyDates),
        name: camelCaseToSentenceCase(phaseItem.phase.trim()),
      })) ?? [];

  return dealStages;
};
